export default {"src":"/_next/static/media/odlo.c286ee7e.svg","height":80,"width":184,"blurWidth":0,"blurHeight":0};